import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ToastContext = createContext({ addToast: () => {}, removeToast: () => {} });

let idSeq = 1;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((t) => t.filter((x) => x.id !== id));
  }, []);

  const addToast = useCallback((opts) => {
    const id = idSeq++;
    const { message, type = 'success', duration = 2500 } = opts || {};
    setToasts((t) => [...t, { id, message, type }]);
    if (duration > 0) {
      setTimeout(() => removeToast(id), duration);
    }
    return id;
  }, [removeToast]);

  const value = useMemo(() => ({ addToast, removeToast }), [addToast, removeToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      {/* Toast container */}
      <div className="fixed top-4 right-4 z-[100] space-y-2">
        {toasts.map((t) => (
          <div key={t.id} className={`min-w-[240px] max-w-sm px-4 py-3 rounded-xl shadow-lg border text-sm transition transform ${t.type === 'error' ? 'bg-red-600 text-white border-red-700' : t.type === 'warning' ? 'bg-yellow-500 text-black border-yellow-600' : 'bg-black text-white border-gray-800'}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">{t.message}</div>
              <button className="opacity-80 hover:opacity-100" onClick={() => removeToast(t.id)}>✕</button>
            </div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);

export default { ToastProvider, useToast };